import React, { useEffect, useState } from 'react';
import CreateEditAccount from './createEdit';
import { useDispatch } from 'react-redux';
import CustomTable from 'components/CustomTable';
import CustomButton from 'components/CustomInput/Button/index';
import { CREATE_REVIEWER, DELETE_REVIEWER, EDIT_REVIEWER, GET_REVIEWER_LIST } from 'store/key';
import useReviewer from './useReviewer';
import CustomPagination from 'components/CustomPagination';
import ResetPassword from './resetPassword';
import useDialog from 'components/ConfirmDialog/useDialog';
import PageSize from 'components/CustomTable/PageSize';
import { Grid } from '@material-ui/core';
import {
    CREATED_REVIEWER,
    UPDATED_REVIEWER,
    DELETED_REVIEWER,
} from 'utility/frontendMessage';

const ReviewerMaintenance = (props) => {
    const [openPopup, setOpenPopup] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const showDialog = useDialog();
    const dispatch = useDispatch();

    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        getReviewerList();
        // eslint-disable-next-line
    }, []);

    const handleCreate = (row) => {
        setSelectedRow(null);
        setOpenPopup(true);
    };
    const refleshReviewerList = () => {
        setOpenPopup(false);
        getReviewerList(page, pageSize, sort, isDesc);
    };

    const createRow = (data) => {
        dispatch({
            type: CREATE_REVIEWER,
            payload: { data, callback: () => {
                    refleshReviewerList()
                    showDialog({
                        description: CREATED_REVIEWER,
                        disableCancelButton: true,
                    });
                }
            },
        });
    };

    const editRow = (data, isUserEdit) => {
        dispatch({
            type: EDIT_REVIEWER,
            payload: { data, callback: () => {
                    refleshReviewerList()
                    const desc = isUserEdit ? UPDATED_REVIEWER : CREATED_REVIEWER;
                    showDialog({
                        description: desc,
                        disableCancelButton: true,
                    });
                }
            },
        });
    };

    const deleteRow = (row) => {
        dispatch({
            type: DELETE_REVIEWER,
            payload: {
                id: row.id,
                callback: () => {
                    refleshReviewerList()
                    showDialog({
                        description: DELETED_REVIEWER,
                        disableCancelButton: true,
                    });
                }
            },
        });
    };

    const getReviewerList = (newPage, newPageSize, newSort, newIsDesc) => {
        setIsLoading(true);
        const params = {
            page: newPage ?? page,
            pageSize: newPageSize ?? pageSize,
            sort: newSort ?? sort,
            isDesc: newIsDesc ?? isDesc,
        };

        dispatch({
            type: GET_REVIEWER_LIST,
            payload: {
                params,
                callback: () => setIsLoading(false)
            },
        });
    };

    const changePageSize = async (value) => {
        setPageSize(value);
        getReviewerList(null, value, null, null);
    };

    const changePage = (value) => {
        setPage(value);
        getReviewerList(value, null, null, null);
    };

    const {
        columns,
        rows,
        total,
        setIsResetPassword,
        isResetPassword,
        sort,
        isDesc,
    } = useReviewer({
        setOpenPopup,
        setSelectedRow,
        getReviewerList,
    });

    return (
        <div style={{ padding: 15 }}>
            {openPopup && (
                <CreateEditAccount
                    openPopup={openPopup}
                    rowData={selectedRow}
                    editReviewer={editRow}
                    setOpenPopup={setOpenPopup}
                    createReviewer={createRow}
                />
            )}
            {isResetPassword && (
                <ResetPassword
                    rowData={selectedRow}
                    setOpenPopup={setIsResetPassword}
                    openPopup={isResetPassword}
                />
            )}
            <Grid container justify='space-between'>
                <CustomButton onClick={handleCreate}>Create</CustomButton>
                <PageSize label={"Page Size"} value={pageSize} onChange={changePageSize} isLoading={isLoading} />
            </Grid>
            <div style={{ marginTop: 20 }}>
                <CustomTable
                    loading={isLoading}
                    columns={columns}
                    rows={rows}
                    allowResize
                    isDeleteAllow
                    onDelete={deleteRow}
                    defaultSortKey={sort}
                    isDesc={isDesc}
                    isSortable
                />
            </div>
            <div style={{ marginTop: 20 }}>
                <CustomPagination page={page} pageSize={pageSize} total={total} isLoading={isLoading} onPageChange={changePage} />
            </div>
        </div>
    );
};

export default ReviewerMaintenance;
